import { useEventListener as Fe, unrefElement as Me, tryOnUnmounted as je } from "@vueuse/core";
import { watch as D, isReadonly as be, shallowRef as ee, markRaw as te, nextTick as Ze, computed as X, ref as Y, toRaw as z, unref as fe, readonly as Se } from "vue-demi";
import { toRef as m, whenever as pe, isDefined as l, tryOnUnmounted as ue, toValue as B, notNullish as N, useToggle as $e } from "@vueuse/shared";
import { Map as Ge, latLngBounds as Je, latLng as ge, TileLayer as de, GridLayer as qe, LayerGroup as Ve, Util as q, Marker as we, GeoJSON as Le, ImageOverlay as Pe, VideoOverlay as Oe, DomUtil as ke, SVGOverlay as Ie, Path as Ke, Polyline as Ce, Polygon as Ne, Rectangle as xe, CircleMarker as Ae, Circle as Ee, Tooltip as ce, Popup as le, Control as ae, Icon as he, DivIcon as Qe } from "leaflet";
import { logicAnd as ne } from "@vueuse/math";
function Re(O, I, g) {
  return Fe(O, I, g, void 0);
}
function Te(O, I = {}) {
  const {
    remove: g,
    isRemoved: h,
    watch: s,
    cleanRef: o,
    cleanVal: c = null,
    flushSync: v,
    dispose: f
  } = I, i = m(O), _ = v ? "sync" : void 0;
  let a = !1;
  D(
    i,
    (t, r) => {
      a ? a = !1 : !t && r && y(r);
    },
    { flush: _ }
  ), s && pe(
    s,
    () => {
      P();
    },
    { flush: _ }
  );
  function y(t) {
    !((h == null ? void 0 : h(t)) ?? !1) && (g == null || g(t));
  }
  function P() {
    l(i) && (y(i.value), o && !be(i) && (a = !0, i.value = c));
  }
  return f && ue(() => {
    P();
  }), P;
}
function ze(O, I = {}) {
  const {
    remove: g = (f) => f.off().remove(),
    isRemoved: h = (f) => !f._map,
    cleanRef: s = !0,
    flushSync: o = !0,
    dispose: c = !0,
    ...v
  } = I;
  return Te(O, {
    remove: g,
    isRemoved: h,
    cleanRef: s,
    flushSync: o,
    dispose: c,
    ...v
  });
}
function ft(O, I = {}) {
  const {
    center: g = [0, 0],
    zoom: h = 0,
    bounds: s,
    useFly: o = !1,
    flushSync: c,
    factory: v,
    dispose: f = !0,
    onViewChanged: i,
    ..._
  } = I, a = ee(null);
  function y(e) {
    const d = { ..._ }, w = B(s) || B(o);
    w || (d.center = B(g), d.zoom = B(h));
    const E = typeof v == "function" ? v(e, d) : new Ge(e, d);
    w && t(E), a.value = te(E);
  }
  function P(e) {
    return e.setView([0, 0], 0);
  }
  function t(e) {
    B(s) ? B(o) ? P(e).flyToBounds(B(s)) : e.fitBounds(B(s)) : B(o) && P(e).flyTo(
      B(g),
      B(h)
    );
  }
  function r(e) {
    var d, w;
    e = Je(e), e.isValid() && (B(o) ? (d = a.value) == null || d.flyToBounds(e) : (w = a.value) == null || w.fitBounds(e));
  }
  function p(e, d) {
    var w, E;
    B(o) ? (w = a.value) == null || w.flyTo(e, d) : (E = a.value) == null || E.setView(e, d);
  }
  function A(e) {
    var d, w;
    B(o) ? (d = a.value) == null || d.flyTo(e) : (w = a.value) == null || w.panTo(e);
  }
  function S(e) {
    var d, w, E;
    B(o) ? (w = a.value) == null || w.flyTo((d = a.value) == null ? void 0 : d.getCenter(), e) : (E = a.value) == null || E.setZoom(e);
  }
  function b(e, d) {
    return e === d ? !0 : !l(e) || !l(d) ? !1 : ge(e).equals(ge(d));
  }
  const u = ze(a, {
    isRemoved: (e) => !e.getContainer()._leaflet_id,
    dispose: f
  });
  return D(
    () => B(s),
    (e) => {
      e && r(e);
    }
  ), D(
    () => ({
      center: B(g),
      zoom: B(h)
    }),
    (e, d) => {
      !b(e.center, d.center) && e.zoom !== d.zoom ? l(e.center) && p(e.center, e.zoom) : b(e.center, d.center) ? e.zoom !== d.zoom && l(e.zoom) && S(e.zoom) : l(e.center) && A(e.center);
    }
  ), D(
    () => Me(O),
    (e) => {
      u(), e && y(e);
    },
    {
      immediate: !0,
      flush: c ? "sync" : "post"
    }
  ), i && Re(a, "moveend", (e) => {
    const d = e.sourceTarget;
    i({
      center: d.getCenter(),
      zoom: d.getZoom(),
      bounds: d.getBounds(),
      ...e
    });
  }), a;
}
function ve(O, I = {}) {
  const { watch: g, flushSync: h } = I, s = ee(null), o = h ? "sync" : void 0;
  function c() {
    s.value = te(O());
  }
  if (g) {
    const v = m(g);
    if (v.value)
      c();
    else {
      const f = D(
        v,
        (i) => {
          i && (Ze(() => f()), c());
        },
        { flush: o }
      );
    }
  } else
    c();
  return s;
}
function Q(O, I = {}) {
  const { watch: g, flushSync: h, updateSources: s, remove: o, dispose: c } = I, v = ve(O, {
    watch: g,
    flushSync: h
  }), f = h ? "sync" : void 0;
  Array.isArray(s) && s.forEach(i);
  function i(_) {
    const { handler: a, options: y } = _;
    D(
      _.watch,
      (P, t) => {
        v.value && a(v.value, P, t);
      },
      { flush: f, ...y }
    );
  }
  return ze(v, {
    remove: o,
    dispose: c
  }), v;
}
function Xe(O, I = {}) {
  const { factory: g, updateSources: h = [], dispose: s, ...o } = I, c = m(O);
  h.push({
    watch: c,
    handler: (i, _) => {
      N(_) && i.setUrl(_);
    }
  });
  const v = Q(f, {
    watch: c,
    updateSources: h,
    dispose: s
  });
  function f() {
    return g ? g(c.value, o) : new de(c.value, o);
  }
  return v;
}
function pt(O, I, g = {}) {
  const {
    factory: h,
    updateSources: s = [],
    dispose: o,
    defParams: c = de.WMS.prototype.defaultWmsParams,
    ...v
  } = g, f = m(I);
  N(I) && s.push({
    watch: f,
    options: { deep: !0 },
    handler: (a, y) => {
      y ? a.setParams(y) : c && a.setParams(c);
    }
  });
  const i = Xe(O, {
    factory: _,
    updateSources: s,
    dispose: o,
    ...v,
    ...f.value
  });
  function _(a, y) {
    return h ? h(a, y) : new de.WMS(a, y);
  }
  return i;
}
function dt(O, I = {}) {
  const { factory: g, updateSources: h, dispose: s, ...o } = I, c = Q(v, {
    updateSources: h,
    dispose: s
  });
  function v() {
    if (g)
      return g(O, o);
    {
      const f = qe.extend({ createTile: O });
      return new f(o);
    }
  }
  return c;
}
function We(O, I, g = {}) {
  const { enabled: h = !0, diffFn: s, update: o, add: c, remove: v, watchOptions: f } = g, i = D(
    () => [...B(O)],
    (y, P) => {
      if (h)
        if (N(P)) {
          const { add: t, remove: r } = (s ?? _)(
            y,
            P
          );
          v == null || v(r), c == null || c(t);
        } else
          c == null || c(y);
      else
        o == null || o(y, P);
    },
    { deep: !0, ...f }
  );
  function _(y, P) {
    return {
      add: a(y, P, I),
      remove: a(P, y, I)
    };
  }
  function a(y, P, t) {
    return y.filter((r) => !P.some((p) => t(r, p)));
  }
  return i;
}
function ht(O, I = {}) {
  const { diff: g, compareFn: h, factory: s, updateSources: o, dispose: c, ...v } = I, f = X(() => {
    const p = B(O);
    if (!N(p))
      return [];
    const A = r(p), S = [];
    for (let b = 0, u = A.length; b < u; b++) {
      const e = B(A[b]);
      N(e) && S.push(e);
    }
    return S;
  }), i = Q(_, {
    updateSources: o,
    dispose: c
  });
  We(f, h ?? t, {
    enabled: g !== !1,
    diffFn: typeof g == "function" ? g : void 0,
    update: a,
    add: y,
    remove: P
  });
  function _() {
    return s ? s(f.value, v) : new Ve(f.value, v);
  }
  function a(p) {
    var A;
    (A = i.value) == null || A.clearLayers(), y(p);
  }
  function y(p) {
    var A;
    for (let S = 0, b = p.length; S < b; S++)
      (A = i.value) == null || A.addLayer(p[S]);
  }
  function P(p) {
    var A;
    for (let S = 0, b = p.length; S < b; S++)
      (A = i.value) == null || A.removeLayer(p[S]);
  }
  function t(p, A) {
    return q.stamp(p) === q.stamp(A);
  }
  function r(p) {
    return Array.isArray(p) ? p : [p];
  }
  return i;
}
function vt(O, I = {}) {
  const {
    icon: g,
    opacity: h,
    zIndexOffset: s,
    draggable: o,
    factory: c,
    dispose: v,
    defOptions: f,
    updateSources: i = [],
    ..._
  } = I, a = m(O), y = m(g), P = m(h), t = m(s), r = m(o), p = f ?? we.prototype.options;
  i.push({
    watch: a,
    handler: (u, e) => {
      N(e) && u.setLatLng(e);
    }
  }), N(g) && i.push({
    watch: y,
    handler: (u, e) => {
      u.setIcon(e ?? p.icon);
    }
  }), N(h) && i.push({
    watch: P,
    handler: (u, e) => {
      u.setOpacity(e ?? p.opacity);
    }
  }), N(s) && i.push({
    watch: t,
    handler: (u, e) => {
      u.setZIndexOffset(e ?? p.zIndexOffset);
    }
  }), N(o) && i.push({
    watch: r,
    handler: (u, e) => {
      const { dragging: d, options: w } = u;
      w.draggable = e ?? p.draggable, w.draggable ? d && !d.enabled() && d.enable() : d && d.enabled() && d.disable();
    }
  });
  const A = Q(S, {
    watch: a,
    updateSources: i,
    dispose: v
  });
  function S() {
    return c ? c(a.value, b()) : new we(a.value, b());
  }
  function b() {
    const u = {
      ..._
    };
    return l(y) && (u.icon = y.value), l(P) && (u.opacity = P.value), l(t) && (u.zIndexOffset = t.value), l(r) && (u.draggable = r.value), u;
  }
  return N(o) && Re(A, "moveend", () => {
    !be(a) && l(A) && (a.value = A.value.getLatLng().clone());
  }), A;
}
function mt(O, I = {}) {
  const {
    style: g,
    error: h,
    watchDeep: s,
    updateSources: o = [],
    factory: c,
    dispose: v,
    ...f
  } = I, i = m(O), _ = Y(h), a = Y(g);
  o.push({
    watch: i,
    handler: (r, p) => {
      if (r.clearLayers(), N(p)) {
        const A = z(p);
        try {
          r.addData(A), _.value = null;
        } catch (S) {
          _.value = S;
        }
      }
    },
    options: {
      deep: s
    }
  }), N(g) && o.push({
    watch: a,
    handler: (r, p) => {
      r.options.style = p, N(p) ? r.setStyle(p) : r.resetStyle();
    },
    options: {
      deep: !0
    }
  });
  const y = Q(P, {
    updateSources: o,
    dispose: v
  });
  function P() {
    if (c)
      return c(z(i.value), t());
    try {
      return new Le(z(i.value), t());
    } catch (r) {
      return _.value = r, new Le(void 0, t());
    }
  }
  function t() {
    const r = {
      ...f
    };
    return l(a) && (r.style = a.value), r;
  }
  return y;
}
function yt(O, I, g = {}) {
  const {
    opacity: h,
    alt: s,
    zIndex: o,
    className: c,
    factory: v,
    dispose: f,
    defOptions: i,
    updateSources: _ = [],
    ...a
  } = g, y = m(O), P = m(I), t = m(h), r = m(s), p = m(o), A = m(c), S = i ?? Pe.prototype.options;
  _.push({
    watch: y,
    handler: (d, w) => {
      w && d.setUrl(w);
    }
  }), _.push({
    watch: P,
    handler: (d, w) => {
      w && d.setBounds(z(w));
    }
  }), N(h) && _.push({
    watch: t,
    handler: (d, w) => {
      d.setOpacity(w ?? S.opacity);
    }
  }), N(s) && _.push({
    watch: r,
    handler: (d, w) => {
      d.options.alt = w ?? S.alt;
      const E = d.getElement();
      E && (E.alt = d.options.alt);
    }
  }), N(o) && _.push({
    watch: p,
    handler: (d, w) => {
      d.setZIndex(w ?? S.zIndex);
    }
  }), N(c) && _.push({
    watch: A,
    handler: (d, w, E) => {
      d.options.className = w ?? S.className;
      const W = d.getElement();
      W && (E && W.classList.remove(...q.splitWords(E)), d.options.className && W.classList.add(...q.splitWords(d.options.className)));
    }
  });
  const b = Q(u, {
    watch: ne(y, P),
    updateSources: _,
    dispose: f
  });
  function u() {
    return v ? v(y.value, z(P.value), e()) : new Pe(
      y.value,
      z(P.value),
      e()
    );
  }
  function e() {
    const d = {
      ...a
    };
    return l(t) && (d.opacity = t.value), l(r) && (d.alt = r.value), l(p) && (d.zIndex = p.value), l(A) && (d.className = A.value), d;
  }
  return b;
}
function _t(O, I, g = {}) {
  const {
    autoplay: h,
    loop: s,
    keepAspectRatio: o,
    muted: c,
    playsInline: v,
    opacity: f,
    zIndex: i,
    className: _,
    factory: a,
    dispose: y,
    defOptions: P,
    updateSources: t = [],
    ...r
  } = g, p = m(O), A = m(I), S = m(h), b = m(s), u = m(o), e = m(c), d = m(v), w = m(f), E = m(i), W = m(_), H = P ?? Oe.prototype.options;
  t.push({
    watch: p,
    handler: (n, x) => {
      typeof x == "string" ? n.setUrl(x) : Array.isArray(x) ? M(n, x) : x instanceof HTMLVideoElement && M(n, Z(x));
    }
  }), t.push({
    watch: A,
    handler: (n, x) => {
      x && n.setBounds(z(x));
    }
  }), N(h) && t.push({
    watch: S,
    handler: (n, x) => {
      n.options.autoplay = x ?? H.autoplay;
      const L = n.getElement();
      L && (L.autoplay = !!n.options.autoplay);
    }
  }), N(s) && t.push({
    watch: b,
    handler: (n, x) => {
      n.options.loop = x ?? H.loop;
      const L = n.getElement();
      L && (L.loop = !!n.options.loop);
    }
  }), N(o) && t.push({
    watch: u,
    handler: (n, x) => {
      n.options.keepAspectRatio = x ?? H.keepAspectRatio;
      const L = n.getElement();
      L && L.style.objectFit !== void 0 && (L.style.objectFit = n.options.keepAspectRatio ? "" : "fill");
    }
  }), N(c) && t.push({
    watch: e,
    handler: (n, x) => {
      n.options.muted = x ?? H.muted;
      const L = n.getElement();
      L && (L.muted = !!n.options.muted);
    }
  }), N(v) && t.push({
    watch: d,
    handler: (n, x) => {
      n.options.playsInline = x ?? H.playsInline;
      const L = n.getElement();
      L && (L.playsInline = !!n.options.playsInline);
    }
  }), N(f) && t.push({
    watch: w,
    handler: (n, x) => {
      n.setOpacity(x ?? H.opacity);
    }
  }), N(i) && t.push({
    watch: E,
    handler: (n, x) => {
      n.setZIndex(x ?? H.zIndex);
    }
  }), N(_) && t.push({
    watch: W,
    handler: (n, x, L) => {
      n.options.className = x ?? H.className;
      const C = n.getElement();
      C && (L && C.classList.remove(...q.splitWords(L)), n.options.className && C.classList.add(...q.splitWords(n.options.className)));
    }
  });
  const $ = Q(J, {
    watch: ne(p, A),
    updateSources: t,
    dispose: y
  });
  function J() {
    return a ? a(z(p.value), z(A.value), R()) : new Oe(
      z(p.value),
      z(A.value),
      R()
    );
  }
  function R() {
    const n = {
      ...r
    };
    return l(S) && (n.autoplay = S.value), l(b) && (n.loop = b.value), l(u) && (n.keepAspectRatio = u.value), l(e) && (n.muted = e.value), l(d) && (n.playsInline = d.value), l(w) && (n.opacity = w.value), l(E) && (n.zIndex = E.value), l(W) && (n.className = W.value), n;
  }
  function G(n, x) {
    n.replaceChildren();
    for (let L = 0; L < x.length; L++) {
      const C = x[L];
      if (C) {
        const k = ke.create("source");
        k.src = C, n.appendChild(k);
      }
    }
  }
  function Z(n) {
    const x = n.getElementsByTagName("source"), L = [];
    for (let C = 0; C < x.length; C++)
      L.push(x[C].src);
    return x.length > 0 ? L : [n.src];
  }
  function M(n, x) {
    n._url = x;
    const L = n.getElement();
    L && G(L, x);
  }
  return $;
}
function gt(O, I, g = {}) {
  const {
    opacity: h,
    zIndex: s,
    className: o,
    factory: c,
    dispose: v,
    defOptions: f,
    updateSources: i = [],
    ..._
  } = g, a = m(O), y = m(I), P = m(h), t = m(s), r = m(o), p = f ?? Ie.prototype.options;
  i.push({
    watch: a,
    handler: (u, e) => {
      if (e instanceof SVGElement) {
        const d = u;
        d._url = e, d._initImage(), d._updateOpacity(), d._updateZIndex(), d._map && d._reset();
      }
    }
  }), i.push({
    watch: y,
    handler: (u, e) => {
      e && u.setBounds(z(e));
    }
  }), N(h) && i.push({
    watch: P,
    handler: (u, e) => {
      u.setOpacity(e ?? p.opacity);
    }
  }), N(s) && i.push({
    watch: t,
    handler: (u, e) => {
      u.setZIndex(e ?? p.zIndex);
    }
  }), N(o) && i.push({
    watch: r,
    handler: (u, e, d) => {
      u.options.className = e ?? p.className;
      const w = u.getElement();
      w && (d && w.classList.remove(...q.splitWords(d)), u.options.className && w.classList.add(...q.splitWords(u.options.className)));
    }
  });
  const A = Q(S, {
    watch: ne(a, y),
    updateSources: i,
    dispose: v
  });
  function S() {
    return c ? c(z(a.value), z(y.value), b()) : new Ie(
      z(a.value),
      z(y.value),
      b()
    );
  }
  function b() {
    const u = {
      ..._
    };
    return l(P) && (u.opacity = P.value), l(t) && (u.zIndex = t.value), l(r) && (u.className = r.value), u;
  }
  return A;
}
function Ue(O, I = {}) {
  const {
    stroke: g,
    color: h,
    weight: s,
    opacity: o,
    lineCap: c,
    lineJoin: v,
    dashArray: f,
    dashOffset: i,
    fill: _,
    fillColor: a,
    fillOpacity: y,
    fillRule: P,
    className: t,
    watch: r,
    dispose: p,
    defOptions: A,
    updateSources: S = [],
    ...b
  } = I ?? {}, u = m(g), e = m(h), d = m(s), w = m(o), E = m(c), W = m(v), H = m(f), $ = m(i), J = m(_), R = m(a), G = m(y), Z = m(P), M = m(t), n = A ?? Ke.prototype.options;
  N(g) && k("stroke", u), N(h) && k("color", e), N(s) && k("weight", d), N(o) && k("opacity", w), N(c) && k("lineCap", E), N(v) && k("lineJoin", W), N(f) && k("dashArray", H), N(i) && k("dashOffset", $), N(_) && k("fill", J), N(a) && k("fillColor", R), N(y) && k("fillOpacity", G), N(P) && k("fillRule", Z), N(t) && S.push({
    watch: M,
    handler: (U, V, se) => {
      U.options.className = V ?? n.className;
      const oe = U.getElement();
      oe && (se && oe.classList.remove(...q.splitWords(se)), U.options.className && oe.classList.add(...q.splitWords(U.options.className)));
    }
  });
  const x = Q(L, {
    watch: r,
    updateSources: S,
    dispose: p
  });
  function L() {
    return O(C());
  }
  function C() {
    const U = {
      ...b
    };
    return l(u) && (U.stroke = u.value), l(e) && (U.color = e.value), l(d) && (U.weight = d.value), l(w) && (U.opacity = w.value), l(E) && (U.lineCap = E.value), l(W) && (U.lineJoin = W.value), l(H) && (U.dashArray = H.value), l($) && (U.dashOffset = $.value), l(J) && (U.fill = J.value), l(R) && (U.fillColor = R.value), l(G) && (U.fillOpacity = G.value), l(Z) && (U.fillRule = Z.value), l(M) && (U.className = M.value), U;
  }
  function k(U, V) {
    S.push({
      watch: V,
      handler: (se, oe) => {
        se.setStyle({ [U]: oe ?? n[U] });
      }
    });
  }
  return x;
}
function Ye(O, I = {}) {
  const {
    smoothFactor: g,
    noClip: h,
    watchDeep: s,
    factory: o,
    defOptions: c,
    updatePoints: v,
    updateSources: f = [],
    ...i
  } = I, _ = m(O), a = m(g), y = m(h), P = c ?? Ce.prototype.options;
  f.push({
    watch: _,
    handler: v ?? ((A, S) => {
      S && A.setLatLngs(z(S));
    }),
    options: {
      deep: s
    }
  }), N(g) && f.push({
    watch: a,
    handler: (A, S) => {
      A.options.smoothFactor = S ?? P.smoothFactor, A.redraw();
    }
  }), N(h) && f.push({
    watch: y,
    handler: (A, S) => {
      A.options.noClip = S ?? P.noClip, A.redraw();
    }
  });
  const t = Ue(r, {
    ...i,
    defOptions: P,
    updateSources: f,
    watch: _
  });
  function r(A) {
    return o ? o(z(_.value), p(A)) : new Ce(z(_.value), p(A));
  }
  function p(A) {
    const S = A;
    return l(a) && (S.smoothFactor = a.value), l(y) && (S.noClip = y.value), S;
  }
  return t;
}
function et(O, I = {}) {
  const {
    factory: g = c,
    defOptions: h = Ne.prototype.options,
    ...s
  } = I, o = Ye(O, {
    factory: g,
    defOptions: h,
    ...s
  });
  function c(v, f) {
    return new Ne(v, f);
  }
  return o;
}
function wt(O, I = {}) {
  const {
    factory: g = v,
    updatePoints: h = f,
    defOptions: s = xe.prototype.options,
    ...o
  } = I, c = et(O, {
    factory: g,
    defOptions: s,
    updatePoints: h,
    ...o
  });
  function v(i, _) {
    return new xe(i, _);
  }
  function f(i, _) {
    _ && i.setBounds(z(_));
  }
  return c;
}
function tt(O, I = {}) {
  const {
    radius: g,
    factory: h,
    defOptions: s = Ae.prototype.options,
    updateSources: o = [],
    ...c
  } = I, v = m(O), f = m(g);
  o.push({
    watch: v,
    handler: (y, P) => {
      P && y.setLatLng(z(P));
    }
  }), N(g) && o.push({
    watch: f,
    handler: (y, P) => {
      y.setRadius(P ?? s.radius);
    }
  });
  const i = Ue(_, {
    ...c,
    defOptions: s,
    updateSources: o,
    watch: v
  });
  function _(y) {
    return h ? h(z(v.value), a(y)) : new Ae(z(v.value), a(y));
  }
  function a(y) {
    const P = y;
    return l(f) && (P.radius = f.value), P;
  }
  return i;
}
function Lt(O, I = {}) {
  const {
    factory: g = c,
    defOptions: h = Ee.prototype.options,
    ...s
  } = I, o = tt(O, {
    factory: g,
    defOptions: h,
    ...s
  });
  function c(v, f) {
    return new Ee(v, f);
  }
  return o;
}
function Pt(O, I = {}) {
  const {
    offset: g,
    direction: h,
    opacity: s,
    content: o,
    className: c,
    source: v,
    defOptions: f,
    updateSources: i = [],
    factory: _,
    dispose: a,
    ...y
  } = I, P = m(O), t = m(g), r = m(h), p = m(s), A = m(c), S = Y(o), b = m(v), u = f ?? ce.prototype.options;
  N(O) && i.push({
    watch: P,
    handler: (E, W) => {
      W && E.setLatLng(z(W));
    }
  }), N(g) && i.push({
    watch: t,
    handler: (E, W) => {
      E.options.offset = z(W) ?? u.offset, E.update();
    }
  }), N(h) && i.push({
    watch: r,
    handler: (E, W) => {
      E.options.direction = W ?? u.direction, E.update();
    }
  }), N(s) && i.push({
    watch: p,
    handler: (E, W) => {
      E.setOpacity(W ?? u.opacity);
    }
  }), N(o) && i.push({
    watch: S,
    handler: (E, W) => {
      E.setContent(W ?? u.content);
    }
  }), N(c) && i.push({
    watch: A,
    handler: (E, W, H) => {
      E.options.className = W ?? u.className;
      const $ = E.getElement();
      $ && (H && $.classList.remove(...q.splitWords(H)), E.options.className && $.classList.add(...q.splitWords(E.options.className)));
    }
  });
  const e = Q(d, {
    watch: N(O) ? P : void 0,
    updateSources: i,
    dispose: a
  });
  function d() {
    return l(b) ? _ ? _(w(), z(b.value)) : new ce(w(), z(b.value)) : _ ? _(z(P.value), w()) : new ce(z(P.value), w());
  }
  function w() {
    const E = {
      ...y
    };
    return l(t) && (E.offset = z(t.value)), l(r) && (E.direction = r.value), l(p) && (E.opacity = p.value), l(A) && (E.className = A.value), l(S) && (E.content = S.value), E;
  }
  return e;
}
function Ot(O, I = {}) {
  const {
    offset: g,
    maxWidth: h,
    minWidth: s,
    maxHeight: o,
    keepInView: c,
    autoPan: v,
    autoPanPaddingTopLeft: f,
    autoPanPaddingBottomRight: i,
    autoPanPadding: _,
    content: a,
    className: y,
    source: P,
    defOptions: t,
    updateSources: r = [],
    factory: p,
    dispose: A,
    ...S
  } = I, b = m(O), u = m(g), e = m(h), d = m(s), w = m(o), E = m(c), W = m(v), H = m(f), $ = m(i), J = m(_), R = m(y), G = Y(a), Z = m(P), M = t ?? le.prototype.options;
  N(O) && r.push({
    watch: b,
    handler: (C, k) => {
      k && C.setLatLng(z(k));
    }
  }), N(g) && r.push({
    watch: u,
    handler: (C, k) => {
      C.options.offset = z(k) ?? M.offset, C.update();
    }
  }), N(h) && r.push({
    watch: e,
    handler: (C, k) => {
      C.options.maxWidth = k ?? M.maxWidth, C.update();
    }
  }), N(s) && r.push({
    watch: d,
    handler: (C, k) => {
      C.options.minWidth = k ?? M.minWidth, C.update();
    }
  }), N(o) && r.push({
    watch: w,
    handler: (C, k) => {
      C.options.maxHeight = k ?? M.maxHeight, C.update();
    }
  }), N(v) && r.push({
    watch: W,
    handler: (C, k) => {
      C.options.autoPan = k ?? M.autoPan;
    }
  }), N(f) && r.push({
    watch: H,
    handler: (C, k) => {
      C.options.autoPanPaddingTopLeft = z(k) ?? M.autoPanPaddingTopLeft;
    }
  }), N(i) && r.push({
    watch: $,
    handler: (C, k) => {
      C.options.autoPanPaddingBottomRight = z(k) ?? M.autoPanPaddingBottomRight;
    }
  }), N(_) && r.push({
    watch: J,
    handler: (C, k) => {
      C.options.autoPanPadding = z(k) ?? M.autoPanPadding;
    }
  }), N(a) && r.push({
    watch: G,
    handler: (C, k) => {
      C.setContent(k ?? M.content);
    }
  }), N(y) && r.push({
    watch: R,
    handler: (C, k, U) => {
      C.options.className = k ?? M.className;
      const V = C.getElement();
      V && (U && V.classList.remove(...q.splitWords(U)), C.options.className && V.classList.add(...q.splitWords(C.options.className)));
    }
  }), N(c) && r.push({
    watch: E,
    handler: (C, k) => {
      C.options.keepInView = k ?? M.keepInView;
      const U = C._map;
      U && (U.off("moveend", C._adjustPan), C.options.keepInView && U.on("moveend", C._adjustPan));
    }
  });
  const n = Q(x, {
    watch: N(O) ? b : void 0,
    updateSources: r,
    dispose: A
  });
  function x() {
    return l(Z) ? p ? p(L(), z(Z.value)) : new le(L(), z(Z.value)) : p ? p(z(b.value), L()) : new le(z(b.value), L());
  }
  function L() {
    const C = {
      ...S
    };
    return l(u) && (C.offset = z(u.value)), l(e) && (C.maxWidth = e.value), l(d) && (C.minWidth = d.value), l(w) && (C.maxHeight = w.value), l(E) && (C.keepInView = E.value), l(W) && (C.autoPan = W.value), l(H) && (C.autoPanPaddingTopLeft = H.value), l($) && (C.autoPanPaddingBottomRight = $.value), l(J) && (C.autoPanPadding = J.value), l(R) && (C.className = R.value), l(G) && (C.content = G.value), C;
  }
  return n;
}
function It(O, I, g = {}) {
  const {
    offset: h,
    direction: s,
    opacity: o,
    className: c,
    visible: v = !1,
    autoBind: f = !0,
    defOptions: i,
    updateSources: _ = [],
    dispose: a = !0,
    ...y
  } = g, P = ee(null), t = m(O), r = Y(I), p = m(v), A = m(h), S = m(s), b = m(o), u = m(c), e = i ?? ce.prototype.options, d = {
    get value() {
      return P.value;
    },
    set value(L) {
      L || E();
    }
  };
  _.push({
    watch: p,
    handler: (L, C) => {
      C ? H() : $();
    }
  }), N(h) && _.push({
    watch: A,
    handler: (L, C) => {
      const k = L.getTooltip();
      k && (k.options.offset = z(C) ?? e.offset, k.update());
    }
  }), N(s) && _.push({
    watch: S,
    handler: (L, C) => {
      const k = L.getTooltip();
      k && (k.options.direction = C ?? e.direction, k.update());
    }
  }), N(o) && _.push({
    watch: b,
    handler: (L, C) => {
      const k = L.getTooltip();
      k && k.setOpacity(C ?? e.opacity);
    }
  }), N(I) && _.push({
    watch: r,
    handler: (L, C) => {
      L.setTooltipContent(C ?? e.content);
    }
  }), N(c) && _.push({
    watch: u,
    handler: (L, C, k) => {
      const U = L.getTooltip();
      if (!U)
        return;
      U.options.className = C ?? e.className;
      const V = U.getElement();
      V && (k && V.classList.remove(...q.splitWords(k)), U.options.className && V.classList.add(...q.splitWords(U.options.className)));
    }
  });
  function w() {
    if (!l(t))
      return;
    t.value.bindTooltip(
      r.value ?? e.content,
      n()
    ).on("add", M).on("tooltipopen", G).on("tooltipclose", Z);
    const L = t.value.getTooltip();
    L && (P.value = te(L));
  }
  function E() {
    W(t.value);
  }
  function W(L) {
    N(L) && L.unbindTooltip().off("add", M).off("tooltipopen", G).off("tooltipclose", Z), P.value = null;
  }
  function H(L) {
    var C;
    (C = t.value) == null || C.openTooltip(L);
  }
  function $() {
    var L;
    (L = t.value) == null || L.closeTooltip();
  }
  function J() {
    var L;
    (L = t.value) != null && L._map && t.value.toggleTooltip();
  }
  function R() {
    var L;
    return (L = t.value) != null && L.getTooltip() ? t.value.isTooltipOpen() : !1;
  }
  function G() {
    p.value = !0;
  }
  function Z() {
    p.value = !1;
  }
  function M() {
    p.value && H();
  }
  function n() {
    const L = {
      ...y
    };
    return l(A) && (L.offset = z(A.value)), l(S) && (L.direction = S.value), l(b) && (L.opacity = b.value), l(u) && (L.className = u.value), L;
  }
  function x(L) {
    const { handler: C, options: k } = L;
    D(
      L.watch,
      (U, V) => {
        t.value && C(t.value, U, V);
      },
      { ...k }
    );
  }
  return f && D(
    t,
    (L, C) => {
      C && W(C), L && w();
    },
    { immediate: !0 }
  ), _.forEach(x), a && ue(() => {
    E();
  }), {
    visible: p,
    tooltip: d,
    bind: w,
    unbind: E,
    open: H,
    close: $,
    toggle: J,
    isOpened: R
  };
}
function Ct(O, I, g = {}) {
  const {
    offset: h,
    maxWidth: s,
    minWidth: o,
    maxHeight: c,
    keepInView: v,
    autoPan: f,
    autoPanPaddingTopLeft: i,
    autoPanPaddingBottomRight: _,
    autoPanPadding: a,
    className: y,
    visible: P = !1,
    autoBind: t = !0,
    defOptions: r,
    updateSources: p = [],
    dispose: A = !0,
    ...S
  } = g, b = ee(null), u = m(O), e = Y(I), d = m(P), w = m(h), E = m(s), W = m(o), H = m(c), $ = m(v), J = m(f), R = m(i), G = m(_), Z = m(a), M = m(y), n = r ?? le.prototype.options, x = {
    get value() {
      return b.value;
    },
    set value(T) {
      T || C();
    }
  };
  p.push({
    watch: d,
    handler: (T, j) => {
      j ? U() : V();
    }
  }), N(h) && p.push({
    watch: w,
    handler: (T, j) => {
      const F = T.getPopup();
      F && (F.options.offset = z(j) ?? n.offset, F.update());
    }
  }), N(s) && p.push({
    watch: E,
    handler: (T, j) => {
      const F = T.getPopup();
      F && (F.options.maxWidth = j ?? n.maxWidth, F.update());
    }
  }), N(o) && p.push({
    watch: W,
    handler: (T, j) => {
      const F = T.getPopup();
      F && (F.options.minWidth = j ?? n.minWidth, F.update());
    }
  }), N(c) && p.push({
    watch: H,
    handler: (T, j) => {
      const F = T.getPopup();
      F && (F.options.maxHeight = j ?? n.maxHeight, F.update());
    }
  }), N(f) && p.push({
    watch: J,
    handler: (T, j) => {
      const F = T.getPopup();
      F && (F.options.autoPan = j ?? n.autoPan);
    }
  }), N(i) && p.push({
    watch: R,
    handler: (T, j) => {
      const F = T.getPopup();
      F && (F.options.autoPanPaddingTopLeft = z(j) ?? n.autoPanPaddingTopLeft);
    }
  }), N(_) && p.push({
    watch: G,
    handler: (T, j) => {
      const F = T.getPopup();
      F && (F.options.autoPanPaddingBottomRight = z(j) ?? n.autoPanPaddingBottomRight);
    }
  }), N(a) && p.push({
    watch: Z,
    handler: (T, j) => {
      const F = T.getPopup();
      F && (F.options.autoPanPadding = z(j) ?? n.autoPanPadding);
    }
  }), N(I) && p.push({
    watch: e,
    handler: (T, j) => {
      T.setPopupContent(j ?? n.content);
    }
  }), N(y) && p.push({
    watch: M,
    handler: (T, j, F) => {
      const K = T.getPopup();
      if (!K)
        return;
      K.options.className = j ?? n.className;
      const re = K.getElement();
      re && (F && re.classList.remove(...q.splitWords(F)), K.options.className && re.classList.add(...q.splitWords(K.options.className)));
    }
  }), N(v) && p.push({
    watch: $,
    handler: (T, j) => {
      const F = T.getPopup();
      if (!F)
        return;
      F.options.keepInView = j ?? n.keepInView;
      const K = T._map;
      K && (K.off("moveend", T._adjustPan), F.options.keepInView && K.on("moveend", T._adjustPan));
    }
  });
  function L() {
    if (!l(u))
      return;
    u.value.bindPopup(e.value ?? n.content, De()).on("add", _e).on("popupopen", me).on("popupclose", ye);
    const T = u.value.getPopup();
    T && (b.value = te(T));
  }
  function C() {
    k(u.value);
  }
  function k(T) {
    N(T) && T.unbindPopup().off("add", _e).off("popupopen", me).off("popupclose", ye), b.value = null;
  }
  function U(T) {
    var j;
    (j = u.value) == null || j.openPopup(T);
  }
  function V() {
    var T;
    (T = u.value) == null || T.closePopup();
  }
  function se() {
    var T;
    (T = u.value) != null && T._map && u.value.togglePopup();
  }
  function oe() {
    var T;
    return ((T = u.value) == null ? void 0 : T.isPopupOpen()) ?? !1;
  }
  function me() {
    d.value = !0;
  }
  function ye() {
    d.value = !1;
  }
  function _e() {
    d.value && U();
  }
  function De() {
    const T = {
      ...S
    };
    return l(w) && (T.offset = z(w.value)), l(E) && (T.maxWidth = E.value), l(W) && (T.minWidth = W.value), l(H) && (T.maxHeight = H.value), l($) && (T.keepInView = $.value), l(J) && (T.autoPan = J.value), l(R) && (T.autoPanPaddingTopLeft = R.value), l(G) && (T.autoPanPaddingBottomRight = G.value), l(Z) && (T.autoPanPadding = Z.value), l(M) && (T.className = M.value), T;
  }
  function He(T) {
    const { handler: j, options: F } = T;
    D(
      T.watch,
      (K, re) => {
        u.value && j(u.value, K, re);
      },
      { ...F }
    );
  }
  return t && D(
    u,
    (T, j) => {
      j && k(j), T && L();
    },
    { immediate: !0 }
  ), p.forEach(He), A && ue(() => {
    C();
  }), {
    visible: d,
    popup: x,
    bind: L,
    unbind: C,
    open: U,
    close: V,
    toggle: se,
    isOpened: oe
  };
}
function Nt(...O) {
  return ne(...O);
}
function nt(O, I = {}) {
  const { current: g, changed: h, add: s, remove: o, nameTemplate: c = (i) => `${i}` } = I, v = X(() => Array.isArray(B(O)) ? B(O).filter((i) => !!B(i.layer)).map((i, _) => {
    const a = z(B(i.layer));
    return {
      name: i.name ?? c(_ + 1, a),
      layer: z(B(i.layer)),
      overlay: !1
    };
  }) : []), f = X(() => {
    const i = B(g);
    if (i == null)
      return null;
    const a = typeof i == "number" ? v.value[i] : v.value.find((y) => y.name === i);
    return !a || !B(a.layer) ? null : {
      name: a.name,
      layer: z(B(a.layer)),
      overlay: !1
    };
  });
  return h && D(
    v,
    (i) => {
      h(i);
    },
    { deep: !0 }
  ), (s || o) && D(f, (i, _) => {
    _ && (o == null || o(_)), i && (s == null || s(i));
  }), {
    layers: v,
    currentLayer: f
  };
}
function ot(O, I = {}) {
  const { current: g, changed: h, add: s, remove: o, nameTemplate: c = (a) => `${a}` } = I, v = X(() => Array.isArray(B(O)) ? B(O).filter((a) => !!B(a.layer)).map((a, y) => {
    const P = z(B(a.layer));
    return {
      name: a.name ?? c(y + 1, P),
      layer: z(B(a.layer)),
      overlay: !0
    };
  }) : []), f = X(() => {
    const a = B(g);
    if (!Array.isArray(a))
      return [];
    const y = [];
    for (const P of a) {
      let t;
      typeof P == "number" && v.value[P] ? t = v.value[P] : t = v.value.find((r) => r.name === P), t && B(t.layer) && y.push({
        name: t.name,
        layer: z(B(t.layer)),
        overlay: !0
      });
    }
    return y;
  });
  h && D(
    v,
    (a) => {
      h(a);
    },
    { deep: !0 }
  ), (s || o) && D(
    () => [...f.value],
    (a, y) => {
      const P = _(a, y, i), t = _(y, a, i);
      o && t.forEach((r) => o(r)), s && P.forEach((r) => s(r));
    },
    { deep: !0 }
  );
  function i(a, y) {
    return q.stamp(a.layer) === q.stamp(y.layer);
  }
  function _(a, y, P) {
    return a.filter((t) => !y.some((r) => P(t, r)));
  }
  return {
    layers: v,
    currentLayers: f
  };
}
function ie(O, I = {}) {
  const {
    remove: g = (f) => f.remove(),
    isRemoved: h = (f) => !f._map,
    cleanRef: s = !0,
    flushSync: o = !0,
    dispose: c = !0,
    ...v
  } = I;
  return Te(O, {
    remove: g,
    isRemoved: h,
    cleanRef: s,
    flushSync: o,
    dispose: c,
    ...v
  });
}
function xt(O, I = {}) {
  const {
    currentBaseLayer: g,
    currentOverlays: h,
    indexes: s = !1,
    factory: o,
    dispose: c = !0,
    ...v
  } = I, f = ee(null), i = Y(g), _ = Y(h), a = m(O), { layers: y, currentLayer: P } = nt(
    X(() => {
      var n;
      return (n = a.value) == null ? void 0 : n.filter(({ overlay: x }) => !x);
    }),
    {
      current: i,
      changed: (n) => W(n, !1),
      add: (n) => R(n.layer),
      remove: (n) => G(n.layer)
    }
  ), { layers: t, currentLayers: r } = ot(
    X(() => {
      var n;
      return (n = a.value) == null ? void 0 : n.filter(({ overlay: x }) => x);
    }),
    {
      current: _,
      changed: (n) => W(n, !0),
      add: (n) => R(n.layer),
      remove: (n) => G(n.layer)
    }
  );
  function p() {
    const n = o ? o(v) : new ae.Layers(
      void 0,
      void 0,
      v
    );
    f.value = te(S(n));
  }
  function A() {
    W(y.value, !1), W(t.value, !0);
  }
  function S(n) {
    const x = n.onAdd, L = n.onRemove;
    return n.onAdd = (C) => {
      const k = x.call(n, C);
      return u(C), b(C), k;
    }, n.onRemove = (C) => {
      L.call(n, C), e(C);
    }, n;
  }
  function b(n) {
    P.value && R(P.value.layer, n), r.value.forEach(({ layer: x }) => R(x, n));
  }
  function u(n) {
    n.on("baselayerchange", d).on("overlayadd", w).on("overlayremove", E);
  }
  function e(n) {
    n.off("baselayerchange", d).off("overlayadd", w).off("overlayremove", E);
  }
  function d(n) {
    s ? i.value = Z(y.value, n.layer) : i.value = n.name;
  }
  function w(n) {
    if (l(_) || (_.value = []), s) {
      const x = Z(t.value, n.layer), L = _.value;
      x !== void 0 && !L.includes(x) && L.push(x);
    } else {
      const x = _.value;
      !x.includes(n.name) && x.push(n.name);
    }
  }
  function E(n) {
    if (l(_) || (_.value = []), s) {
      const x = _.value, L = Z(t.value, n.layer);
      L !== void 0 && M(x, L);
    } else {
      const x = _.value;
      M(x, n.name);
    }
  }
  function W(n, x) {
    $(x), H(n), J();
  }
  function H(n) {
    n.forEach((x) => {
      var L;
      (L = f.value) == null || L._addLayer(
        x.layer,
        x.name,
        x.overlay
      );
    });
  }
  function $(n) {
    const x = f.value, L = x._layers, C = [], k = [];
    L.forEach((U) => {
      U.overlay ? k.push(U) : C.push(U);
    }), (n ? k : C).forEach((U) => {
      var V;
      (V = U.layer) == null || V.off("add remove", x._onLayerChange, x);
    }), x._layers = [...n ? C : k];
  }
  function J() {
    const n = f.value;
    n != null && n._map && n._update();
  }
  function R(n, x) {
    var L;
    x = x ?? ((L = f.value) == null ? void 0 : L._map), x && !x.hasLayer(n) && x.addLayer(n);
  }
  function G(n, x) {
    var L;
    x = x ?? ((L = f.value) == null ? void 0 : L._map), x && x.hasLayer(n) && x.removeLayer(n);
  }
  function Z(n, x) {
    const L = n.findIndex((C) => C.layer === x);
    return L > -1 ? L : void 0;
  }
  function M(n, x) {
    const L = n.indexOf(x);
    L > -1 && n.splice(L, 1);
  }
  return ie(f, { dispose: c }), p(), A(), f;
}
function At(O = {}) {
  const {
    attributions: I,
    prefix: g,
    factory: h,
    dispose: s = !0,
    ...o
  } = O, c = ee(null), v = m(I), f = m(g);
  function i() {
    const t = h ? h(o) : new ae.Attribution(o);
    c.value = te(t);
  }
  function _() {
    var t;
    f.value !== void 0 && ((t = c.value) == null || t.setPrefix(f.value)), l(v) && a(v.value);
  }
  function a(t) {
    t.forEach((r) => {
      var p;
      return (p = c.value) == null ? void 0 : p.addAttribution(r);
    });
  }
  function y(t) {
    t.forEach((r) => {
      var p;
      return (p = c.value) == null ? void 0 : p.removeAttribution(r);
    });
  }
  function P(t, r) {
    return t.filter((p) => !r.includes(p));
  }
  return ie(c, { dispose: s }), D(f, (t) => {
    var r;
    (r = c.value) == null || r.setPrefix(t);
  }), D(
    () => l(v) ? [...v.value] : [],
    (t, r) => {
      r && t ? (y(P(r, t)), a(P(t, r))) : r ? y(r) : t && a(t);
    }
  ), i(), _(), c;
}
function Et(O = {}) {
  const { disabled: I, factory: g, dispose: h = !0, ...s } = O, o = ee(null), c = m(I);
  function v() {
    const a = g ? g(s) : new ae.Zoom(s);
    o.value = te(a);
  }
  function f() {
    fe(c) ? _() : i();
  }
  function i() {
    const a = o.value;
    a && typeof a.enable == "function" && a._map && a.enable();
  }
  function _() {
    const a = o.value;
    a && typeof a.disable == "function" && a._map && a.disable();
  }
  return ie(o, { dispose: h }), D(c, f), v(), f(), o;
}
function bt(O = {}) {
  const { factory: I, dispose: g = !0, ...h } = O, s = ee(null);
  function o() {
    const c = I ? I(h) : new ae.Scale(h);
    s.value = te(c);
  }
  return ie(s, { dispose: g }), o(), s;
}
function St(O = {}) {
  const {
    disabled: I,
    factory: g,
    dispose: h = !0,
    onAdd: s = () => document.createElement("div"),
    onRemove: o,
    onEnable: c,
    onDisable: v,
    ...f
  } = O, i = ee(null), _ = m(I);
  function a() {
    const t = g ? g(f) : new ae(f);
    i.value = te(y(t));
  }
  function y(t) {
    return t.onAdd = (r) => {
      const p = s(r, t);
      return P(), p;
    }, t.onRemove = (r) => {
      o == null || o(r, t);
    }, t;
  }
  function P() {
    var r;
    const t = (r = i.value) == null ? void 0 : r._map;
    t && (fe(_) ? v == null || v(t, i.value) : c == null || c(t, i.value));
  }
  return ie(i, {
    dispose: h
  }), D(_, P), a(), P(), i;
}
function kt(O = {}) {
  const { factory: I, dispose: g = !0, ...h } = O, s = ee(null);
  function o() {
    const v = I ? I(h) : c() && new ae.Locate(
      h
    );
    s.value = te(v);
  }
  function c() {
    if (typeof ae.Locate != "function")
      throw new Error(
        'Leaflet extension not installed: "@leaflet-extensions/locatecontrol"'
      );
    return !0;
  }
  return ie(s, { dispose: g }), o(), s;
}
function at(O, I, g = {}) {
  const {
    initialValue: h = !0,
    controls: s = !1,
    flushSync: o = !1,
    dispose: c = !1,
    onToggle: v
  } = g, f = m(h), i = $e(f), _ = o ? "sync" : void 0;
  function a(P) {
    const t = B(O), r = B(I);
    t && r && (v == null || v(t, r, P));
  }
  function y() {
    fe(f) && a(fe(f));
  }
  return D(f, a, {
    flush: _
  }), pe(
    ne(O, I),
    () => {
      y();
    },
    { flush: _ }
  ), c && je(() => {
    a(!1);
  }), y(), s ? {
    toggle: i,
    value: f
  } : i;
}
function Be(O, I, g = {}) {
  const { show: h, hide: s, shown: o, flushSync: c, ...v } = g, f = m(O), i = m(I), _ = c ? "sync" : void 0, a = at(O, I, {
    ...v,
    flushSync: c,
    onToggle: y
  });
  function y(t, r, p) {
    p ? !((o == null ? void 0 : o(t, r)) ?? !1) && (h == null || h(t, r)) : ((o == null ? void 0 : o(t, r)) ?? !0) && (s == null || s(t, r));
  }
  function P() {
    return !!(f.value && i.value && (o != null && o(f.value, i.value)));
  }
  if (D(
    i,
    (t, r) => {
      f.value && (!t && r ? y(f.value, r, !1) : t && !r ? y(f.value, t, !0) : t && r && t !== r && (y(f.value, r, !1), y(f.value, t, !0)));
    },
    { flush: _ }
  ), g.controls) {
    const { toggle: t, value: r } = a;
    return {
      toggle: t,
      value: r,
      show: () => {
        t(!0);
      },
      hide: () => {
        t(!1);
      },
      shown: P
    };
  }
  return a;
}
function Rt(O, I, g = {}) {
  return Be(O, I, {
    ...g,
    show: (h, s) => h.addLayer(s),
    hide: (h, s) => h.removeLayer(s),
    shown: (h, s) => h.hasLayer(s)
  });
}
function Tt(O, I, g = {}) {
  return Be(O, I, {
    ...g,
    show: (h, s) => h.addControl(s),
    hide: (h, s) => h.removeControl(s),
    shown: (h, s) => !!s._map
  });
}
function zt(O, I, g = {}) {
  const { flushSync: h, dispose: s } = g, o = m(O), c = Y({}), v = h ? "sync" : void 0, f = X(
    () => p(B(I))
  );
  function i() {
    l(o) && l(f) && (_(o.value, f.value), y());
  }
  function _(u, e) {
    p(e).forEach((d) => {
      P(u, d) || t(u, d);
    });
  }
  function a(u, e) {
    const d = r(u);
    p(e).forEach((w) => {
      const [E, W] = w, H = E + W;
      d[H] && (d[H].remove(), delete d[H]);
    });
  }
  function y() {
    l(o) && (c.value = { ...r(o.value) });
  }
  function P(u, e) {
    const [d, w] = e, E = u._controlCorners;
    return E ? !!E[d + w] : !1;
  }
  function t(u, e) {
    const [d, w] = e, E = u._controlCorners, W = u._controlContainer;
    if (!W || !E)
      return;
    const H = `leaflet-${d} leaflet-${w}`;
    E[d + w] = ke.create(
      "div",
      H,
      W
    );
  }
  function r(u) {
    return u._controlCorners ?? {};
  }
  function p(u) {
    return Array.isArray(u) ? u.length === 0 || Array.isArray(u[0]) ? u : [u] : [];
  }
  function A(u, e) {
    return u[0] + u[1] === e[0] + e[1];
  }
  const S = We(f, A, {
    add: (u) => {
      l(o) && (_(o.value, u), y());
    },
    remove: (u) => {
      l(o) && (a(o.value, u), y());
    },
    watchOptions: { flush: v }
  });
  pe(
    ne(o, f),
    () => {
      i();
    },
    {
      flush: v
    }
  );
  function b() {
    l(o) && l(f) && (a(o.value, f.value), y());
  }
  return s && ue(() => {
    b(), S();
  }), i(), {
    positionElements: Se(
      c
    )
  };
}
function Wt(O, I, g = {}) {
  const { zIndex: h, flushSync: s, dispose: o } = g, c = m(O), v = m(I), f = m(h), i = Y({}), _ = s ? "sync" : void 0, a = X(
    () => A(v.value ?? []).map((b) => i.value[b])
  );
  function y() {
    l(c) && l(v) && (P(c.value, v.value), r());
  }
  function P(b, u) {
    A(u).forEach((e) => {
      if (!b.getPane(e)) {
        const d = b.createPane(e);
        l(f) && (d.style.zIndex = `${f.value}`);
      }
    });
  }
  function t(b, u) {
    const e = b.getPanes();
    A(u).forEach((d) => {
      e[d] && (e[d].remove(), delete e[d]);
    });
  }
  function r() {
    l(c) && (i.value = { ...c.value.getPanes() });
  }
  function p(b, u) {
    return b.filter((e) => !u.includes(e));
  }
  function A(b) {
    return Array.isArray(b) ? b : [b];
  }
  D(
    () => {
      if (l(v))
        return Array.isArray(v.value) ? [...v.value] : [v.value];
    },
    (b, u) => {
      l(c) && (u && b ? (t(c.value, p(u, b)), P(c.value, p(b, u)), r()) : u ? (t(c.value, u), r()) : b && (P(c.value, b), r()));
    },
    { deep: !0, flush: _ }
  ), pe(
    ne(c, v),
    () => {
      y();
    },
    {
      flush: _
    }
  ), N(h) && D(f, (b) => {
    a.value.forEach((u) => {
      u.style.zIndex = `${b ?? ""}`;
    });
  });
  function S() {
    l(c) && l(v) && (t(c.value, v.value), r());
  }
  return o && ue(() => {
    S();
  }), y(), {
    currentPanes: a,
    paneElements: Se(i)
  };
}
function Ut(O, ...I) {
  return X(
    () => ne(...I).value ? B(O) : void 0
  );
}
function st(O, I = {}) {
  const {
    iconRetinaUrl: g,
    iconAnchor: h,
    iconSize: s,
    shadowUrl: o,
    shadowRetinaUrl: c,
    shadowSize: v,
    shadowAnchor: f,
    className: i,
    knownClasses: _,
    factory: a,
    ...y
  } = I, P = m(O), t = m(g), r = m(h), p = m(s), A = m(o), S = m(c), b = m(v), u = m(f), e = m(i), d = m(() => [
    ...B(_) ?? [],
    "leaflet-zoom-animated",
    "leaflet-zoom-hide",
    "leaflet-interactive"
  ]), w = ve(E, {
    watch: P
  });
  function E() {
    const R = typeof a == "function" ? a(W()) : new he(W());
    return H(R);
  }
  function W() {
    const R = { ...y };
    return R.iconUrl = P.value, l(t) && (R.iconRetinaUrl = t.value), l(r) && (R.iconAnchor = r.value), l(p) && (R.iconSize = p.value), l(A) && (R.shadowUrl = A.value), l(S) && (R.shadowRetinaUrl = S.value), l(b) && (R.shadowSize = b.value), l(u) && (R.shadowAnchor = u.value), l(e) && (R.className = e.value), R;
  }
  function H(R) {
    const G = R.createIcon, Z = R.createShadow;
    return R.createIcon = function(M) {
      return this._iconElement = G.call(this, M), this._iconElement;
    }, R.createShadow = function(M) {
      return this._shadowElement = Z.call(this, M), this._shadowElement;
    }, R;
  }
  function $(R, G) {
    const Z = R[`_${G}Element`];
    Z instanceof HTMLImageElement && (Z.src = R._getIconUrl(G));
  }
  function J(R, G) {
    const Z = R[`_${G}Element`];
    if (Z) {
      const M = d.value, n = [...Z.classList].filter((x) => M.includes(x));
      R._setIconStyles(Z, G), n.forEach((x) => Z.classList.add(x));
    }
  }
  return D(P, (R) => {
    l(w) && (w.value.options.iconUrl = R ?? "", $(w.value, "icon"));
  }), N(g) && D(t, (R) => {
    l(w) && (w.value.options.iconRetinaUrl = R ?? "", $(w.value, "icon"));
  }), N(s) && D(p, (R) => {
    l(w) && (w.value.options.iconSize = R, J(w.value, "icon"));
  }), N(h) && D(r, (R) => {
    l(w) && (w.value.options.iconAnchor = R, J(w.value, "icon"));
  }), N(o) && D(A, (R) => {
    l(w) && (w.value.options.shadowUrl = R ?? "", $(w.value, "shadow"));
  }), N(c) && D(S, (R) => {
    l(w) && (w.value.options.shadowRetinaUrl = R ?? "", $(w.value, "shadow"));
  }), N(v) && D(b, (R) => {
    l(w) && (w.value.options.shadowSize = R, J(w.value, "shadow"));
  }), N(f) && D(u, (R) => {
    l(w) && (w.value.options.shadowAnchor = R, J(w.value, "shadow"));
  }), N(i) && D(e, (R) => {
    l(w) && (w.value.options.className = R, J(w.value, "icon"), J(w.value, "shadow"));
  }), D(
    d,
    () => {
      l(w) && (J(w.value, "icon"), J(w.value, "shadow"));
    },
    { deep: !0 }
  ), w;
}
function Bt(O = {}) {
  const { iconUrl: I, factory: g = o, ...h } = O, s = m(
    () => B(I) ?? he.Default.prototype.options.iconUrl
  );
  function o(c) {
    return new he.Default(
      c
    );
  }
  return st(s, {
    ...h,
    factory: g
  });
}
function Dt(O, I = {}) {
  const {
    bgPos: g,
    iconAnchor: h,
    iconSize: s,
    className: o,
    knownClasses: c,
    watch: v,
    factory: f,
    ...i
  } = I, _ = m(O), a = m(g), y = m(h), P = m(s), t = m(o), r = m(() => [
    ...B(c) ?? [],
    "leaflet-zoom-animated",
    "leaflet-zoom-hide",
    "leaflet-interactive"
  ]), p = ve(A, {
    watch: v
  });
  function A() {
    const e = typeof f == "function" ? f(S()) : new Qe(S());
    return b(e);
  }
  function S() {
    const e = { ...i };
    return l(_) && (e.html = _.value), l(a) && (e.bgPos = a.value), l(y) && (e.iconAnchor = y.value), l(P) && (e.iconSize = P.value), l(t) && (e.className = t.value), e;
  }
  function b(e) {
    const d = e.createIcon;
    return e.createIcon = function(w) {
      return this._iconElement = d.call(this, w), this._iconElement;
    }, e;
  }
  function u(e) {
    const d = e._iconElement;
    if (d) {
      const w = r.value, E = [...d.classList].filter((W) => w.includes(W));
      e.createIcon(d), E.forEach((W) => d.classList.add(W));
    }
  }
  return N(O) && D(_, (e) => {
    l(p) && (p.value.options.html = e, u(p.value));
  }), N(g) && D(a, (e) => {
    l(p) && (p.value.options.bgPos = e, u(p.value));
  }), N(s) && D(P, (e) => {
    l(p) && (p.value.options.iconSize = e, u(p.value));
  }), N(h) && D(y, (e) => {
    l(p) && (p.value.options.iconAnchor = e, u(p.value));
  }), N(o) && D(t, (e) => {
    l(p) && (p.value.options.className = e, u(p.value));
  }), D(
    r,
    () => {
      l(p) && u(p.value);
    },
    { deep: !0 }
  ), p;
}
export {
  At as useLeafletAttributionControl,
  Lt as useLeafletCircle,
  tt as useLeafletCircleMarker,
  zt as useLeafletControlPosition,
  ve as useLeafletCreate,
  St as useLeafletCustomControl,
  Bt as useLeafletDefaultIcon,
  Ut as useLeafletDeps,
  We as useLeafletDiff,
  Tt as useLeafletDisplayControl,
  Rt as useLeafletDisplayLayer,
  Be as useLeafletDisplayObject,
  Dt as useLeafletDivIcon,
  Re as useLeafletEvent,
  mt as useLeafletGeoJson,
  dt as useLeafletGridLayer,
  st as useLeafletIcon,
  yt as useLeafletImageOverlay,
  Q as useLeafletLayer,
  ht as useLeafletLayerGroup,
  Ct as useLeafletLayerPopup,
  It as useLeafletLayerTooltip,
  xt as useLeafletLayersControl,
  kt as useLeafletLocateControl,
  ft as useLeafletMap,
  vt as useLeafletMarker,
  Wt as useLeafletPane,
  Ue as useLeafletPath,
  et as useLeafletPolygon,
  Ye as useLeafletPolyline,
  Ot as useLeafletPopup,
  Nt as useLeafletReady,
  wt as useLeafletRectangle,
  ie as useLeafletRemoveControl,
  ze as useLeafletRemoveLayer,
  Te as useLeafletRemoveObject,
  bt as useLeafletScaleControl,
  gt as useLeafletSvgOverlay,
  Xe as useLeafletTileLayer,
  at as useLeafletToggleObject,
  Pt as useLeafletTooltip,
  _t as useLeafletVideoOverlay,
  pt as useLeafletWmsTileLayer,
  Et as useLeafletZoomControl
};
